import React, { Component } from 'react';

import {Card} from 'material-ui/Card';
import RaisedButton from 'material-ui/RaisedButton';
import DatePicker from 'material-ui/DatePicker';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Dialog from 'material-ui/Dialog';

import CustomTimePicker from './CustomTimePicker';
import AddressField from './AddressField';
import Util from '../Util';
import Theme from '../Theme';
import Config from '../conf';

class DateTime extends Component {

  constructor(props) {
    super(props);

    this.state = {
      timeDialogOpen: false,
      timeMessage: ''
    };

    this.nextCheck = this.nextCheck.bind(this);
    this.fieldChanged = this.fieldChanged.bind(this);
    this.formatDate = this.formatDate.bind(this);
    this.shouldDisableDate = this.shouldDisableDate.bind(this);
    this.nextDisabled = this.nextDisabled.bind(this);
    this.closeTimeDialog = this.closeTimeDialog.bind(this);
  }
  
  nextDisabled() {
    let ret = !this.props.details.date ||
            !this.props.details.time ||
            !this.props.details.address ||
            !this.props.details.numberPlate ||
            !this.props.details.carType;
    return ret;
  }

  nextCheck() {
    // check that the time is far enough in the future to book
    const date = this.props.details.date;
    const timeSplit = this.props.details.time.split(' to ');
    const startTime = Util.toHoursMinutes(timeSplit[0]);
    const body = {
      date: {
        d: date.getDate(),
        m: date.getMonth(),
        y: date.getFullYear()
      },
      startTime: {
        h: startTime.hours,
        m: startTime.mins
      }
    };
    fetch(Config.BACKEND_API_URL + 'booking/time', {
      method: 'post',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    }).then((response) => {
      return response.json();
    }).then((data) => {
      if (data.result === true) {
        this.props.next();
      } else {
        // not enough time
        this.setState({
          timeMessage: data.message ? data.message : 'An unexpected error occurred. Please try again.',
          timeDialogOpen: true
        });
      }
    }).catch((err) => {
      console.log('Failed to check booking start time', err);
    });
  }

  fieldChanged(fieldName, newValue) {
    this.props.setHasError(fieldName, false);
    this.props.updateField(fieldName, newValue);
  }

  formatDate(date) {
    if (!date) return '';
    return Util.monthToString(date.getMonth()) + ' ' + date.getDate() + ', ' + date.getFullYear();
  }

  shouldDisableDate(date) {
    const current = new Date();
    current.setHours(0);
    current.setMinutes(0);
    current.setSeconds(0);
    current.setMilliseconds(0);
    return date < current;
  }

  closeTimeDialog() {
    this.setState({
      timeDialogOpen: false
    });
  }

  render() {
    const styles = {
      center: {
        textAlign: 'center',
        justifyContent: 'center'
      },
      card: {
        padding: 30,
        paddingTop: 40,
        textAlign: 'center',
        borderRadius: 12
      },
      title: {
        textAlign: 'center',
        margin: 0,
        color: Theme.palette.primary1Color,
        marginBottom: 20
      },
      dateTimeWrapper: {
        width: '80%',
        maxWidth: 440,
        margin: 'auto'
      },
      button: {
        width: 80,
        marginTop: 20,
        marginLeft: 5,
        marginRight: 5
      },
      inputStyle: {
        width: '100%',
        textAlign: 'center',
        justifyContent: 'center'
      },
      textField: {
        padding: 0,
        margin: 0,
        marginTop: -15,
        width: '100%'
      },
      hintStyle: {
        width: '100%',
        color: '#ccc',
        textAlign: 'center',
        justifyContent: 'center'
      },
      dialogButton: {
        margin: 5
      }
    };

    const actions = [
      <RaisedButton
        label="OK"
        primary={false}
        onTouchTap={() => this.closeTimeDialog(false)}
        style={styles.dialogButton}
      />
    ];

    return (
      <div>
        <Dialog
          title="Sorry!"
          actions={actions}
          modal={false}
          open={this.state.timeDialogOpen}
          onRequestClose={this.closeTimeDialog}
          bodyStyle={styles.center}
          titleStyle={styles.center}
          className="counteract-zoom"
        >
          <p>{this.state.timeMessage}</p>
        </Dialog>

        <Card style={styles.card}>
          <h2 style={styles.title}>Booking Details</h2>
          
          <div style={styles.dateTimeWrapper}>
            <DatePicker
              container={this.props.details.isSmallScreen ? 'dialog' : 'inline'}
              hintText="Select Date"
              autoOk={true}
              formatDate={this.formatDate}
              shouldDisableDate={this.shouldDisableDate}
              style={styles.inputStyle}
              inputStyle={styles.inputStyle}
              textFieldStyle={styles.inputStyle}
              hintStyle={styles.hintStyle}
              floatingLabelText={this.props.details.date ? 'Date' : ''}
              value={this.props.details.date}
              onChange={(evt, date) => this.fieldChanged('date', date)}
              errorText={this.props.details.dateError ? 'Please select a date' : ''}
            />
            <CustomTimePicker
              details={this.props.details}
              fieldChanged={this.fieldChanged}
              floatingLabelText={this.props.details.time ? 'Time' : ' '}
            />
            <AddressField
              styles={styles}
              details={this.props.details}
              fieldChanged={this.fieldChanged}
            />
            <TextField
              style={styles.textField}
              hintStyle={styles.hintStyle}
              inputStyle={styles.inputStyle}
              hintText="Number Plate"
              floatingLabelText={this.props.details.numberPlate ? 'Number Plate' : ' '}
              floatingLabelFixed={true}
              maxLength={8}
              onChange={(evt) => this.fieldChanged('numberPlate', evt.target.value.toUpperCase())}
              value={this.props.details.numberPlate}
            />

            <p style={{paddingTop: 15}}>What type of car do you have?</p>
            <SelectField
              style={styles.textField}
              floatingLabelText=""
              value={this.props.details.carType}
              onChange={this.props.setCarType}
            >
              <MenuItem value={'Sedan'} primaryText="Sedan" />
              <MenuItem value={'SUV'} primaryText="SUV" />
            </SelectField>
          </div>

          <RaisedButton style={styles.button}
            label="Back" primary={true} onClick={this.props.back} />
          <RaisedButton style={styles.button} disabled={this.nextDisabled()}
            label="Next" primary={true} onClick={this.nextCheck} />
        </Card>
      </div>
    );
  }
}

export default DateTime;



// WEBPACK FOOTER //
// ./src/components/DateTime.js